import { render, staticRenderFns } from "./homeHero.vue?vue&type=template&id=31ae9962&scoped=true"
import script from "./homeHero.vue?vue&type=script&lang=js"
export * from "./homeHero.vue?vue&type=script&lang=js"
import style0 from "./homeHero.vue?vue&type=style&index=0&id=31ae9962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae9962",
  null
  
)

export default component.exports